import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Tab, Nav } from 'react-bootstrap';
import { useForm, Controller } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import '../styles/Calendar.css';
import '../styles/Search.css';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import CommonUtils from '../utils/siteUtils.js';


const DynamicSearchForm = (props) => {
    const {
        register,
        handleSubmit,
        reset,
        control,
        formState: { errors }
    } = useForm();

    const [searchDisabled, setSearchDisabled] = useState(false);
    const [tabKey, setTabKey] = useState('invoice');
    const [invDateRng, setInvDateRng] = useState([
        null,
        null
    ]);
    const [schedDateRng, setSchedDateRng] = useState([
        null,
        null
    ]);
    const [paymentDateRng, setPaymentDateRng] = useState([
        null,
        null
    ]);
    const [invAmount, setInvAmount] = useState(null);
    const [payAmount, setPayAmount] = useState(null);
    const [invDateError, setInvDateError] = useState('');
    const [schedDateError, setSchedDateError] = useState('');
    const [paymentDateError, setPaymentDateError] = useState('');

    useEffect(() => {
        if (props.isSearchDisabled !== searchDisabled) {
            setSearchDisabled(props.isSearchDisabled);
        }
    }, [props.isSearchDisabled, searchDisabled]);

    const onSubmit = (data) => {

        //  setSearchDisabled(true);
        data["curSupplierId"] = props.curSupplierId;
        data["searchType"] = tabKey;
        data["InvoiceDt"] = {
            startDate: invDateRng[0] ? new Date(invDateRng[0].toDateString()) : null,
            endDate: invDateRng[1] ? new Date(invDateRng[1].toDateString()) : null
        };
        
        data["ScheduledPayDt"] = {
            startDate: schedDateRng[0] ? new Date(schedDateRng[0].toDateString()) : null,
            endDate: schedDateRng[1] ? new Date(schedDateRng[1].toDateString()) : null
        };
        
        data["PaymentDt"] = {
            startDate: paymentDateRng[0] ? new Date(paymentDateRng[0].toDateString()) : null,
            endDate: paymentDateRng[1] ? new Date(paymentDateRng[1].toDateString()) : null
        };

        //US8512092 - Make sure selectors have a value
        if (isNaN(data["invoiceAmtSel"])) {
            data["invoiceAmtSel"] = 1;
        }
        if (isNaN(data["paymentAmtSel"])) {
            data["paymentAmtSel"] = 1;
        }

        if (isNaN(data["paymentStatus"])) {
            data["paymentStatus"] = 0;
        }
        if (isNaN(data["voucherIdSelector"])) {
            data["voucherIdSelector"] = 1;
        }

        data["invoiceAmt"] = (invAmount) ? Number(invAmount) : null;
        data["paymentAmt"] = (payAmount) ? Number(payAmount) : null;
        data["voucherIdSelector"] = Number(data["voucherIdSelector"]);
        data["invoiceAmtSel"] = Number(data["invoiceAmtSel"]);
        data["paymentStatus"] = Number(data["paymentStatus"]);
        data["paymentAmtSel"] = Number(data["paymentAmtSel"]);
        //US8512092 Bug Fix - Ensure voucherId and paymentId are supplied from form
        if (data["voucherId"] === undefined || data["voucherId"] === null) {
            data["voucherId"] = "";
        }
        if (data["paymentId"] === undefined || data["paymentId"] === null) {
            data["paymentId"] = "";
        }       

        //Check if search criteria is supplied
        if (tabKey === "invoice" && data["voucherId"].trim().length === 0 && data["invoiceAmt"] === null && data["paymentStatus"] === 0 && invDateRng[0] === null && schedDateRng[0] === null) {
            data["noSearch"] = "invoice";
        }

        if (tabKey === "payment" && data["paymentId"].trim().length === 0 && data["paymentAmt"] === null && (paymentDateRng[0] === null)) {
            data["noSearch"] = "payment";
        }

        props.onSearchSubmitted(data);
    }

    const onClearForm = () => {
        document.getElementById("searchReqForm").reset();
        reset({ "invoiceAmt": null });
        var update = [null, null];
        setInvDateRng(update);
        setSchedDateRng(update);
        setPaymentDateRng(update);
        //DE770697: Search Criteria Amounts Not Cleared
        //Setting to null doesn't do the trick... but an empty string does. I verified that it captures the data for
        //submission fine after it is set to an empty string. This is mainly a problem with NumberFormat being used.
        setInvAmount("");
        setPayAmount("");   
        props.onSearchSubmitted('');
    }

    const switchSearchTabs = (tab) => {
        onClearForm();
        setTabKey(tab);
    }

    const getMinDate = () => {
        //DE768726 Defect fix - now it allows you to select any past date 2 years back + the current year. Before, it was just 2 years back from today.
        var curDate = new Date();
        var minYear = curDate.getFullYear() - 2;
        var result = new Date(minYear, 0, 1);
        return result;
    }
    const hasValidDates = (values) => {
        if (values[0] !== null && values[1] !== null) {
            return (values[0] < values[1]);
        }
        return true;
    }
    //US7094599 - conditionally display  Scheduled PayDate Range for EMEA
    const schedulePayDateRange_display = () => {
        var curSupplier = CommonUtils.getCurrentSupplier(props.curSupplierId, props.currentUser);
        var isEMEASearch = (curSupplier.vendorSetId.toUpperCase() !== "UHGID");
        if (isEMEASearch) {
            /*** EMEA Display - Hide Scheduled Pay Date Range search criteria */
            return (
                <Col sm={3} md={3}>
                &nbsp;
                </Col>
            )
        }
        else {
            /*** NON-EMEA Display - Show Scheduled Pay Date Range search criteria */
            return (
                <Form.Group as={Col} sm={3} md={3} controlId="formSchedPayDate">
                    <Form.Label className="formLabel">Scheduled Pay Date Range</Form.Label>
                    <Controller
                        control={control}
                        name="ScheduledPayDt"
                        render={({ field }) => (
                            <DateRangePicker
                                format="MM/dd/yyyy"
                                className="form-control"
                                calendarClassName="searchCalendar"
                                onChange={(value) => {
                                    if (value) {
                                        if (hasValidDates(value)) {
                                            setSchedDateRng(value);
                                            setSchedDateError('');
                                        }
                                        else {
                                            setSchedDateError('Invalid Scheduled Payment Dates');
                                        }
                                    }
                                    else {
                                        setSchedDateRng([null, null]);
                                        setSchedDateError('');
                                    }
                                }}

                                value={schedDateRng}
                                showLeadingZeros={true}
                                minDate={getMinDate()}
                                minDetail={'year'}
                                monthPlaceholde={'mm'}
                                rangeDivider={' to '}
                            />
                        )}
                    />
                    <span className="error">{schedDateError}</span>
                </Form.Group>
            )
        }
    }
    return (

        <Container as={Form} encType="multipart/form-data" name="searchForm" id="searchReqForm" onSubmit={handleSubmit(onSubmit)} onReset={onClearForm} fluid className="searchInputArea shadow">
            <Row>
                <Col sm={12}>
                    <Tab.Container className="searchTabs" activeKey={tabKey} onSelect={(k) => switchSearchTabs(k)}>
                        <Row>
                            <Col sm={2}>
                                <Nav variant="pills" className="flex-column searchTypeSel borderCurve">
                                    <div><span id="tabTitle">Choose What to Search</span></div>
                                    <Nav.Item>
                                        <Nav.Link className="searchTabs" eventKey="invoice">Invoice Search</Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link className="searchTabs" eventKey="payment">Payment Search</Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </Col>
                            <Col sm={10}>
                                <Tab.Content>
                                    <Tab.Pane eventKey="invoice">
                                        <Row>
                                            {/*Invoice ID */}
                                            <Form.Group as={Col} sm={2} md={3} controlId="formVoucherIdSel">
                                                <Form.Label className="formLabel">Invoice ID</Form.Label>
                                                <Form.Control as="select" name="voucherIdSel" {...register('voucherIdSelector')} defaultValue="1" className={`form-control form-select ${errors.voucherId ? 'is-invalid' : ''}`}>
                                                    <option value="1">Equal To</option>
                                                    <option value="2">Begins With</option>
                                                    <option value="3">Contains</option>
                                                </Form.Control>
                                            </Form.Group>

                                            <Form.Group as={Col} sm={2} md={3} controlId="formVoucherId">
                                                <Form.Label className="formLabel">&nbsp;&nbsp;</Form.Label>
                                                <Form.Control type="text" name="voucherId" {...register('voucherId')} placeholder=" Enter Invoice ID" className={`form-control ${errors.voucherId ? 'is-invalid' : ''}`} />
                                                <div className="invalid-feedback">{errors.voucherId?.message}</div>
                                            </Form.Group>
                                            {/*Invoice Amount */}
                                            <Form.Group as={Col} sm={2} md={3} controlId="formInvoiceAmtSel">
                                                <Form.Label className="formLabel">Invoice Amount</Form.Label>
                                                <Form.Control as="select" name="invoiceAmtSel" {...register('invoiceAmtSel')} defaultValue="1" className={`form-control form-select ${errors.invoiceId ? 'is-invalid' : ''}`}>
                                                    <option value="1"> Equal To </option>
                                                    <option value="2"> Less Than </option>
                                                    <option value="3"> Less Than, Equal To</option>
                                                    <option value="4"> Greater Than </option>
                                                    <option value="5"> Greater Than, Equal To </option>
                                                </Form.Control>
                                            </Form.Group>
                                            <Form.Group as={Col} sm={2} md={3} controlId="formInvoiceAmt">
                                                <Form.Label className="formLabel">&nbsp;&nbsp;</Form.Label>
                                                <Controller
                                                    control={control}
                                                    name="invoiceAmt"
                                                    render={({ field }) => (
                                                        <NumericFormat
                                                            thousandSeparator={true}
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            decimalSeparator="."
                                                            className="form-control"
                                                            placeholder="Enter Amount"
                                                            value={invAmount}
                                                            onValueChange={(values) => {
                                                                const { value } = values;
                                                                setInvAmount(value)
                                                            }
                                                            }
                                                        />
                                                    )}
                                                />

                                            </Form.Group>
                                        </Row>
                                        <Row>
                                            {/* Payment Status */}
                                            <Form.Group as={Col} sm={2} md={3} controlId="formPaymentStatusSel">
                                                <Form.Label className="formLabel">Payment Status</Form.Label>
                                                <Form.Control as="select" name="paymentStatus" {...register('paymentStatus')} defaultValue="0" className={`form-control form-select ${errors.invoiceId ? 'is-invalid' : ''}`}>
                                                    <option value="0">Select Status</option>
                                                    <option value="1">Any</option>
                                                    <option value="2">Paid</option>
                                                    <option value="3">Pending</option>
                                                </Form.Control>
                                            </Form.Group>
                                            { /* Invoice Date Range */}
                                            <Form.Group as={Col} sm={3} md={3} controlId="invoiceDtRng">
                                                <Form.Label className="formLabel" >Invoice Date Range</Form.Label>
                                               
                                                <Controller
                                                    control={control}
                                                    name="InvoiceDt"
                                                    render={({ field }) => (
                                                        <DateRangePicker
                                                            format="MM/dd/yyyy"
                                                            className="form-control"
                                                            calendarClassName="searchCalendar"
                                                            onChange={(value) => {
                                                                if (value) {

                                                                    if (hasValidDates(value)) {
                                                                        setInvDateRng(value); 
                                                                        setInvDateError('');
                                                                    } else {
                                                                        console.log('Invalid Invoice Dates');
                                                                        setInvDateError('Invalid Invoice Dates');
                                                                    }
                                                                } else {
                                                                    setInvDateRng([null, null]); 
                                                                    setInvDateError('');
                                                                }
                                                            }}                                                           
                                                            value={invDateRng}
                                                            showLeadingZeros={true}
                                                            //shouldCloseCalendar={true}
                                                            minDate={getMinDate()}
                                                            minDetail={'year'}
                                                            monthPlaceholde={'mm'}
                                                            rangeDivider={' to '}
                                                        />
                                                    )}
                                                />
                                                    <span className="error">{invDateError}</span>
                                                 
                                            </Form.Group>
                                            {/*Scheduled Pay Date Ranger  */}
                                            {schedulePayDateRange_display()}

                                            <Col className="actionBtnContainer" sm={{ size: 3, offSet: 5 }} md={{ size: 4, offSet: 4 }}>

                                                <Button variant="primary" disabled={searchDisabled} className="actionBtn right" type="submit">Search</Button>
                                                <Button variant="secondary" className="actionBtn right" onClick={onClearForm}>Clear</Button>
                                            </Col>
                                        </Row>
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="payment">
                                        <Row>
                                            {/*Payment ID */}
                                            <Form.Group as={Col} sm={2} md={3} controlId="formPaymentId">
                                                <Form.Label className="formLabel">Payment ID</Form.Label>
                                                <Form.Control type="text" name="paymentId"  {...register('paymentId')} placeholder="Enter Payment ID" />
                                            </Form.Group>
                                            {/*Payment Amount */}
                                            <Form.Group as={Col} sm={2} md={3} controlId="formPaymentAmtSel">
                                                <Form.Label className="formLabel">Payment Amount</Form.Label>
                                                <Form.Control as="select" name="paymentAmtSel"  {...register('paymentAmtSel')} defaultValue="1" className={`form-control form-select ${errors.invoiceId ? 'is-invalid' : ''}`} >
                                                    <option value="1"> Equal To</option>
                                                    <option value="2"> Less Than</option>
                                                    <option value="3"> Less Than, Equal To</option>
                                                    <option value="4"> Greater Than </option>
                                                    <option value="5"> Greater Than, Equal To </option>
                                                </Form.Control>

                                            </Form.Group>
                                            <Form.Group as={Col} sm={2} md={3} controlId="formPaymentAmt">
                                                <Form.Label className="formLabel">&nbsp;&nbsp;</Form.Label>
                                                <Controller
                                                    control={control}
                                                    name="paymentAmt"
                                                    render={({ field }) => (
                                                        <NumericFormat
                                                            thousandSeparator
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                            decimalSeparator="."
                                                            className="form-control"
                                                            placeholder="Enter Amount"
                                                            value={payAmount}
                                                            onValueChange={(values) => {
                                                                const { value } = values;
                                                                setPayAmount(value)
                                                            }
                                                            }
                                                        />
                                                    )}
                                                />
                                            </Form.Group>

                                        </Row>
                                        <Row>

                                            {/*  Payment Date Range */}
                                            <Form.Group as={Col} sm={3} md={3} controlId="formPaymenteDate">
                                                <Form.Label className="formLabel">Payment Date Range</Form.Label>
                                                <Controller
                                                    control={control}
                                                    name="PaymentDt"
                                                    className="dateRangeSelector"
                                                    render={({ field }) => (
                                                        <DateRangePicker
                                                            format="MM/dd/yyyy"
                                                            className="form-control"
                                                            calendarClassName="searchCalendar"
                                                            onChange={(value) => {
                                                                if (value) {
                                                                    if (hasValidDates(value)) {
                                                                        setPaymentDateRng(value);
                                                                        setPaymentDateError('');
                                                                    }
                                                                    else {
                                                                        setPaymentDateError('Invalid Payment Dates');
                                                                    }
                                                                }
                                                                else {
                                                                    setPaymentDateRng([null, null]);
                                                                    setPaymentDateError('');
                                                                }
                                                            }}
                                                            
                                                            value={paymentDateRng}
                                                            showLeadingZeros={true}
                                                            minDate={getMinDate()}
                                                            minDetail={'year'}
                                                            monthPlaceholde={'mm'}
                                                            rangeDivider={' to '}
                                                        />
                                                    )}
                                                /> 
                                                <span className="error">{paymentDateError}</span>
                                            </Form.Group>
                                            <Col className="actionBtnContainer" sm={{ size: 3, offSet: 5 }} md={{ size: 4, offSet: 4 }}>

                                                <Button variant="primary" disabled={searchDisabled} className="actionBtn right" type="submit">Search</Button>
                                                <Button variant="secondary" className="actionBtn right" onClick={onClearForm}>Clear</Button>
                                            </Col>
                                        </Row>

                                    </Tab.Pane>
                                </Tab.Content >
                            </Col >
                        </Row >

                    </Tab.Container >
                </Col >
            </Row >
        </Container >
    );

}

export default DynamicSearchForm